
import firebase from 'firebase';

const config = {
  apiKey: 'AIzaSyCWcfhi1VD53N__2ELv94-FeeyoAayPjB4',
  authDomain: 'condorwmc.firebaseapp.com',
  databaseURL: 'https://condorwmc.firebaseio.com',
  projectId: 'condorwmc',
  storageBucket: 'condorwmc.appspot.com',
  messagingSenderId: '812041753309'
};

const app = firebase.initializeApp(config)

var storage = firebase.storage().ref();

const database = firebase.database();
//.ref('posts/')



const facebookProvider = new firebase.auth.FacebookAuthProvider()

export { app, database,storage, facebookProvider }



// WEBPACK FOOTER //
// ./src/config/base.js